/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreatePhoneDto } from '../models/work-create-phone-dto';
import { WorkPhone } from '../models/work-phone';
import { WorkUpdatePhoneDto } from '../models/work-update-phone-dto';

@Injectable({ providedIn: 'root' })
export class WorkPhonesV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `phonesV2ControllerCreate()` */
  static readonly PhonesV2ControllerCreatePath = '/v2/phones';

  /**
   * Required permissions: contacts:create, contacts:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `phonesV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  phonesV2ControllerCreate$Response(
    params: {
      body: WorkCreatePhoneDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPhone>> {
    const rb = new RequestBuilder(this.rootUrl, WorkPhonesV2Service.PhonesV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPhone>;
      })
    );
  }

  /**
   * Required permissions: contacts:create, contacts:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `phonesV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  phonesV2ControllerCreate(
    params: {
      body: WorkCreatePhoneDto
    },
    context?: HttpContext
  ): Observable<WorkPhone> {
    return this.phonesV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPhone>): WorkPhone => r.body)
    );
  }

  /** Path part for operation `phonesV2ControllerDelete()` */
  static readonly PhonesV2ControllerDeletePath = '/v2/phones/{id}';

  /**
   * Required permissions: contacts:delete, contacts:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `phonesV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  phonesV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkPhonesV2Service.PhonesV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: contacts:delete, contacts:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `phonesV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  phonesV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.phonesV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `phonesV2ControllerUpdate()` */
  static readonly PhonesV2ControllerUpdatePath = '/v2/phones/{id}';

  /**
   * Required permissions: contacts:update, contacts:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `phonesV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  phonesV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdatePhoneDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPhone>> {
    const rb = new RequestBuilder(this.rootUrl, WorkPhonesV2Service.PhonesV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPhone>;
      })
    );
  }

  /**
   * Required permissions: contacts:update, contacts:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `phonesV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  phonesV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdatePhoneDto
    },
    context?: HttpContext
  ): Observable<WorkPhone> {
    return this.phonesV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPhone>): WorkPhone => r.body)
    );
  }

}
